var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{staticClass:"form"},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Search..."}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"variant":"none"}},[_c('i',{staticClass:"fa fa-search"})])],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2179bfcc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Sidebar/SidebarForm.vue
// module id = ROTX
// module chunks = 1